var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"categories-page"},[(_vm.mode === 'main' && _vm.mainCategoryData)?_c('MainCategory',{attrs:{"categoryData":_vm.mainCategoryData}}):(_vm.mode === 'sub' && _vm.subCategoryData)?_c('SubCategory',{attrs:{"categoryData":_vm.subCategoryData}}):_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loader"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }